
<dp-breadcrumb [breadCrumb]="breadCrumb"></dp-breadcrumb>

<div class="row m-0 mb-3">
    <dp-cards-info-filters class="p-0" [cards]="cardsInfoFilters"
        (mainFilterChanged)="changeCardInfoFilters($event)" (secundaryFilterChanged)="changeCardInfoFilters($event)"></dp-cards-info-filters>
</div>
<div class="row m-0 pb-3">
    <app-home-chart class="p-0"></app-home-chart>
</div>
<div class="row m-0 pb-3">
    <div class="col-12 px-0 pt-3">
        <app-home-table class="col-12"></app-home-table>
    </div>
</div>
